<template>
  <div class="baseselect">
    <div class="baseselect__fillin">
      <label v-if="labelText">{{ labelText }}</label>
      <b-dropdown
        :text="text"
        variant="outline-secondary"
        :class="{
          'default-option': value === null,
          disabled: disabled,
          'required-border': requiredValid
        }"
        :disabled="disabled"
        @hide="clicked = true"
      >
        <b-dropdown-header class="default-option" v-if="headerText">
          {{ headerText }}
        </b-dropdown-header>
        <b-dropdown-divider v-if="headerText"></b-dropdown-divider>
        <template>
          <b-dropdown-item-button
            v-for="(item, index) in options"
            :key="index"
            @click="$emit('select', item.value)"
          >
            {{ item.text }}
          </b-dropdown-item-button>
        </template>
      </b-dropdown>
    </div>
    <p v-if="requiredValid" class="form-error-messgae">此欄位必選</p>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    labelText: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: null
    },
    text: {
      type: String,
      default: '請選擇'
    },
    headerText: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    requiredValid() {
      return (
        !this.disabled && this.required && this.value === null && this.clicked
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.baseselect {
  &__fillin {
    display: flex;
    align-items: center;
  }
  label {
    flex: 0 0 80px;
    margin-bottom: 0;
  }
}

.widerlabel {
  label {
    flex: 0 0 100px;
  }
}

::v-deep .dropdown-menu.show {
  transform: none !important;
  width: 100%;
  height: auto !important;
  max-height: 150px !important;
  overflow: scroll !important;
  top: 40px !important;
  left: -1px !important;
}

::v-deep .dropdown-header {
  padding: 0 0 0 15px;
}

::v-deep .dropdown-item {
  color: #73879c;
  font-size: 13px;
}

::v-deep .dropdown {
  width: 100%;
}

::v-deep .dropdown .btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  text-align: left;
  border: 1px solid #c0c4cc;
  color: #495057;
  &:hover,
  &:active {
    background-color: inherit;
  }
}

::v-deep .dropdown.default-option .btn {
  color: #c0c4cc;
}

::v-deep .dropdown.disabled {
  background-color: #e9ecef;
}

::v-deep .show > .btn-outline-secondary.dropdown-toggle {
  background-color: inherit;
}
</style>
